import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import './ForgotPassword.css';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  if (!token) {
    return (
      <div className="fp-page">
        <div className="fp-card">
          <h2>Nieprawidłowy link</h2>
          <p className="fp-hint">Link resetowania hasła jest nieprawidłowy lub wygasł.</p>
          <Link to="/forgot-password" className="fp-btn">Wyślij nowy link</Link>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 8) { setError('Hasło musi mieć co najmniej 8 znaków'); return; }
    if (password !== confirm) { setError('Hasła nie są identyczne'); return; }
    setLoading(true);
    setError('');
    try {
      const r = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
      });
      const data = await r.json();
      if (!r.ok) { setError(data.detail || 'Błąd'); return; }
      setDone(true);
    } catch {
      setError('Błąd połączenia. Spróbuj ponownie.');
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="fp-page">
        <div className="fp-card">
          <div className="fp-logo">
            <span className="logo-10">10</span><span className="logo-drive">drive</span>
            <span className="logo-moto">moto</span>
          </div>
          <div className="fp-success">
            <div className="fp-icon">✓</div>
            <p>Hasło zostało zmienione. Możesz się teraz zalogować.</p>
            <button className="fp-btn" onClick={() => navigate('/login', { replace: true })}>
              Przejdź do logowania →
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fp-page">
      <div className="fp-card">
        <div className="fp-logo">
          <span className="logo-10">10</span><span className="logo-drive">drive</span>
          <span className="logo-moto">moto</span>
        </div>
        <h2>Nowe hasło</h2>
        <form onSubmit={handleSubmit} className="fp-form">
          <div className="fp-field">
            <label>Nowe hasło</label>
            <input
              type="password" autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="min. 8 znaków"
            />
          </div>
          <div className="fp-field">
            <label>Powtórz hasło</label>
            <input
              type="password" autoComplete="new-password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="powtórz hasło"
              className={error ? 'error' : ''}
            />
            {error && <span className="fp-error">{error}</span>}
          </div>
          <button type="submit" className="fp-btn" disabled={loading}>
            {loading ? 'Zapisywanie...' : 'Zmień hasło'}
          </button>
        </form>
      </div>
    </div>
  );
}
